<div
  class="tw-relative tw-rounded-xl tw-bg-cover tw-bg-center tw-overflow-hidden tw-isolate"
  [ngClass]="
    layout === 'stack'
      ? 'tw-w-full tw-aspect-[358/164] tw-px-6 tw-py-4'
      : 'tw-w-[320px] tb:tw-w-[280px] tw-aspect-[320/202] tw-px-6 tw-py-[22px]'
  "
  style="background-image: url(&quot;/images/card-bg/platinumCredits.png&quot;)"
>
  <app-card-glare
    #glare
    glareCore="rgba(255,255,255,.85)"
    glareSoft="rgba(14,117,116,.07)"
    glareBlend="overlay"
  ></app-card-glare>

  <div class="tw-flex tw-h-full tw-flex-col tw-items-start">
    <!-- Platinum Credits -->
    <span class="tw-font-medium tw-text-[11px] tw-leading-4 tw-text-blue-750/70">
      {{ "platinumCredits" | i18n | uppercase }}
    </span>
    <span
      [ngClass]="layout === 'stack' ? 'tw-mt-4' : 'tw-mt-2.5'"
      class="tw-font-bold tw-text-[32px] tw-leading-10 tw-text-blue-750 tw-tabular-nums tw-font-D-DIN-PRO tw-antialiased"
    >
      <app-odometer-number
        [value]="creditsService.totalPlatinumCredits()"
        (committed)="glare.play()"
      ></app-odometer-number>
    </span>

    <!-- Redeem For -->
    <div class="tw-mt-auto tw-flex tw-flex-col">
      <span class="tw-font-semibold tw-text-2xs tw-leading-[14px] tw-text-blue-750/70">
        {{ "redeemFor" | i18n | uppercase }}
      </span>
      <span class="tw-font-medium tw-text-[13px] tw-leading-[18px] tw-text-blue-750">
        {{ "externalVouchers" | i18n }}
      </span>
    </div>
  </div>
</div>
